export enum AccountType {
  BANESCO = 'BANESCO',
  LOCAL = 'LOCAL',
  INTERNATIONAL = 'INTERNATIONAL',
  REGIONAL = 'REGIONAL',
  SERVICES = 'SERVICES',
  STOCK_EXCHANGE = 'STOCK_EXCHANGE',
  INTER = 'INTER',
  TAXES = 'TAXES'
}
